export const translations = {
  en: {
    company: 'Company',
    product: 'Product',
    technology: 'Technology',
    team: 'Team',
    partners: 'Partners',
    contact: 'Contact',
    imDizzy: "I'm dizzy",
    feelingBetter: "Feeling better",
    copyright: "BUMBLEBEE Inc. © 2025"
  },
  ko: {
    company: '회사',
    product: '제품',
    technology: '기술',
    team: '팀',
    partners: '파트너',
    contact: '문의',
    imDizzy: "어지러워요",
    feelingBetter: "안 어지러워요",
    copyright: "주식회사 범블비 © 2025"
  },
  zh: {
    company: '公司',
    product: '产品',
    technology: '技术',
    team: '团队',
    partners: '合作伙伴',
    contact: '联系我们',
    imDizzy: "我头晕",
    feelingBetter: "好多了",
    copyright: "大黄蜂股份有限公司 © 2025"
  },
  ja: {
    company: '会社',
    product: 'プロダクト',
    technology: 'テクノロジー',
    team: 'チーム',
    partners: 'パートナー',
    contact: 'お問い合わせ',
    imDizzy: "めまいがします",
    feelingBetter: "楽になりました",
    copyright: "株式会社バンブルビ © 2025"
  }
};

export const languages = [
  { code: 'en', name: 'English' },
  { code: 'ko', name: '한국어' },
  { code: 'zh', name: '中文' },
  { code: 'ja', name: '日本語' }
];